import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner'
import InputGroup from 'react-bootstrap/InputGroup'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import Table from 'react-bootstrap/Table'
import { toast } from 'react-toastify'
import Paginacion from 'components/Paginacion'
import api from 'api/api'

import './patentes.css'
import NuevaPatente from './NuevaPatente'
import { DEFAULT_FETCH_CUANTOS } from 'utils/constants'
import { debounce } from 'utils/debounce'
import VerPatente from './VerPatente'
import EliminarPatente from './EliminarPatente'
import EditarPatente from './EditarPatente'
import { getFileData } from 'utils/general'


function Patentes(props) {
	const [fetchDeACuantos, setFetchDeACuantos] = useState(DEFAULT_FETCH_CUANTOS)
	const [numResultados, setNumResultados] = useState(0)
	const [paginaAct, setPaginaAct] = useState(1)
	const [loading, setLoading] = useState(false)

	const [busqueda, setBusqueda] = useState('')
	const [filtroBusqueda, setFiltroBusqueda] = useState('')
	const [patentes, setPatentes] = useState([])
	const [patenteActual, setPatenteActual] = useState()
	const [queMostrar, setQueMostrar] = useState('')

	const opcionesCuantosMostrar = [10, 25, 50]

	const refreshPatentes = async () => {
		try {
			setLoading(true)
			const { datos } = await api.post('p/ver-patentes', {
				cuantos: fetchDeACuantos,
				desde: paginaAct === 1 ? 0 : (paginaAct - 1) * fetchDeACuantos,
				filtros: {
					titulo: [filtroBusqueda],
				}
			})

			setPatentes(datos.patentes)
			setNumResultados(datos.numResultados)
		} catch (error) {
			toast.error('Error de conexión')
			console.error(error)
		} finally {
			setLoading(false)
		}
	}

	const handleBusqueda = (value) => {
		if (value) {
			setFiltroBusqueda(value)
		} else {
			setFiltroBusqueda('')
		}
	}

	const debouceFiltroBusqueda = React.useCallback(
		debounce(handleBusqueda, 400),
		[]
	)

	useEffect(() => {
		debouceFiltroBusqueda(busqueda)
	}, [busqueda])

	useEffect(() => {
		if (paginaAct === 1) {
			refreshPatentes()
		} else {
			setPaginaAct(1)
		}
	}, [filtroBusqueda, fetchDeACuantos])

	useEffect(() => {
		if (!loading) {
			refreshPatentes()
		}
	}, [paginaAct])

	const handleAction = (comunicado, cual) => {
		setPatenteActual(comunicado, setQueMostrar(cual))
	}

	const subirDocumento = async (archivo, key = 'documento') => {
		let fileId = null
		try {
			if (archivo !== null) {
				const serverData = new FormData()
				serverData.append(key, archivo)

				const { datos: respuesta, msg } = await api.post('a/documentos', serverData)
				fileId = respuesta.id
			}
		} catch (error) {
			toast.error('Error ')
		}

		return fileId
	}

	const nuevaPatente = async (data) => {
		const enviar = { ...data }
		if (data.solicitadas) {
			enviar.solicitadasId = await subirDocumento(data.solicitadas)
		}
		if (data.otorgadas) {
			enviar.otorgadasId = await subirDocumento(data.otorgadas)
		}
		delete enviar.solicitadas
		delete enviar.otorgadas

		try {
			const { msg } = await api.post('a/patentes', enviar)
			refreshPatentes()
			setQueMostrar('')
			toast.success(msg)
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		}
	}

	const editarPatente = async (data) => {
		const enviar = { ...data }
		if (data.solicitadas) {
			enviar.solicitadasId = await subirDocumento(data.solicitadas)
		}

		if (data.otorgadas) {
			enviar.otorgadasId = await subirDocumento(data.otorgadas)
		}

		delete enviar.solicitadas
		delete enviar.otorgadas

		try {
			const { msg } = await api.put('a/patentes/' + data.id, enviar)
			refreshPatentes()
			setQueMostrar('')
			toast.success(msg)
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		}
	}

	const eliminarPatente = async (id) => {
		const { msg } = await api.delete('a/patentes/' + id)
		refreshPatentes()
		setQueMostrar('')
		toast.success(msg)
	}

	useEffect(() => {
		if (!loading) {
			refreshPatentes()
		}
	}, [])


	// render
	return (
		<Container fluid id="patentes" className="vh-100">
			<Row className="d-flex no-gutters">
				<Col xs={12} className="mt-2">
					<h1>Patentes</h1>
					<hr />
				</Col>
			</Row>
			<Row className="d-flex no-gutters">
				<Col className="mt-2">
					<Form>
						<Row id="searchbar" className="justify-content-between align-items-center">
							<Col sm={6} md={3} style={{ display: 'block' }}>
								<small>
									<span className="d-none d-sm-inline-block">Mostrar de a</span>
									<Form.Group style={{ display: 'inline-block' }}>
										<Form.Select size="sm" onChange={(e) => setFetchDeACuantos(e.target.value)} className="mx-1">
											{opcionesCuantosMostrar.map((o) => {
												return (
													<option value={o} key={`mostrar-${o}`}>
														{o}
													</option>
												)
											})}
										</Form.Select>
									</Form.Group>
									<span className="ms-2">patentes</span>
								</small>
							</Col>
							<Col md={5} lg={4}>
								<Form.Group controlId="txtBusqueda">
									<InputGroup>
										<Form.Control
											autoFocus
											value={busqueda}
											onChange={(e) => setBusqueda(e.target.value)}
											type="text"
											placeholder="Buscar"
											aria-label="Buscar"
										/>
										<InputGroup.Text><Form.Label className="mb-0"><i className="fa fa-search"></i></Form.Label></InputGroup.Text>
									</InputGroup>
								</Form.Group>
							</Col>
						</Row>
					</Form>
				</Col>
			</Row>
			<Row className="d-flex no-gutters justify-content-between align-items-end mt-2">
				<Col>
					<Button onClick={() => setQueMostrar('nueva')} variant="primary">
						<i className="fa fa-plus"></i> Nueva patente
					</Button>
				</Col>
				<Col className="text-end">
					<small>Total resultados: <strong>{numResultados}</strong></small>
				</Col>
			</Row>
			{/* Table */}
			<Row>
				<Col>
					<Table id="tabla-patentes" className="mt-2" bordered hover>
						<thead>
							<tr>
								<th>Id</th>
								<th>Año</th>
								<th>Solicitadas</th>
								<th>Otorgadas</th>
								<th>Acciones</th>
							</tr>
						</thead>
						<tbody>
							{loading ? (
								<tr>
									<td colSpan="6">
										<Spinner
											animation="border"
											size="lg"
											role="status"
											aria-hidden="true"
											variant="primary"
											className="my-3"
										/>
									</td>
								</tr>
							) : (
								patentes.length === 0 ? (
									<tr>
										<td colSpan="5">
											<Alert variant="info">No se encontraron patentes</Alert>
										</td>
									</tr>
								) : (
									patentes.map((patente, index) => {
										const solicitadasFileData = getFileData(patente.solicitadas?.url)
										const otorgadasFileData = getFileData(patente.otorgadas?.url)

										return (
											<tr key={patente.id}>
												<td>{patente.id}</td>
												<td>{patente.anho}</td>
												<td>{<i className={solicitadasFileData.icono}></i>}</td>
												<td>{<i className={otorgadasFileData.icono}></i>}</td>
												<td>
													<Button
														onClick={() => handleAction(patente, 'ver')}
														className="me-2"
														variant="primary"
													>
														<i className="fa fa-eye"></i>
													</Button>
													<Button
														onClick={() => handleAction(patente, 'editar')}
														className="me-2"
														variant="secondary"
													>
														<i className="fa fa-pencil"></i>
													</Button>
													<Button
														onClick={() => handleAction(patente, 'eliminar')}
														variant="danger"
													>
														<i className="fa fa-trash"></i>
													</Button>
												</td>
											</tr>
										)
									})
								)
							)}
						</tbody>
					</Table>
				</Col>
			</Row>
			<Row>
				<Col>
					<Paginacion
						pagina={paginaAct}
						numPaginas={Math.ceil(numResultados / fetchDeACuantos) || 1}
						setPagina={setPaginaAct}
					/>
				</Col>
			</Row>

			{/* Panel Nuevo */}
			{queMostrar === 'nueva' && (
				<NuevaPatente
					guardar={nuevaPatente}
					setQueMostrar={setQueMostrar}
				/>
			)}
			{/* Panel Ver */}
			{patenteActual && queMostrar === 'ver' &&
				<VerPatente
					patente={patenteActual}
					setQueMostrar={setQueMostrar}
				/>
			}
			{/* Panel Editar */}
			{patenteActual && queMostrar === 'editar' &&
				<EditarPatente
					patenteOriginal={patenteActual}
					setQueMostrar={setQueMostrar}
					guardar={editarPatente}
				/>
			}
			{/* Modal Delete */}
			{
				patenteActual && queMostrar === 'eliminar' &&
				<EliminarPatente
					patente={patenteActual}
					setQueMostrar={setQueMostrar}
					eliminar={eliminarPatente}
				/>
			}
		</Container>
	);
}

export default Patentes